<eazly-loading [isRunning]="isLoading"></eazly-loading>
<div class="viewer-container">
  <div [ngClass]="toggleState? 'viewer-column': 'viewer-column full'">
    <div class="eazlyPreviewDiv">
      <eazly-alert-manager></eazly-alert-manager>
      <iframe id="wysiwygViewer" #wysiwygViewer>
      </iframe>
    </div>
  </div>
  <eazly-palette [myappeaz]="myappeaz" class="palette-column"
    [ngClass]="toggleState? 'palette-column-show': 'palette-column-hide'"></eazly-palette>

</div>
<eazly-visibility-window (onSubmitVisibilityProperties)="bindDataFromVisibilityModal($event)"
  [isI18N]='myappeaz.multilingue'>
</eazly-visibility-window>
<eazly-dynamic-field-configuration-window
  (onSubmitDynamicModificationSettings)="relayDmUpdateFromModalWindowToEazlyEngine($event)"
  [isI18N]='myappeaz.multilingue'>
</eazly-dynamic-field-configuration-window>
<eazly-list-value-editor-window (onSubmitListValue)="relayDmUpdateFromModalWindowToEazlyEngine($event)"
  [isI18N]='myappeaz.multilingue'>
</eazly-list-value-editor-window>
<app-assistant-dialog [myappeaz]="myappeaz" [stepBeingEdited]="stepBeingEdited"></app-assistant-dialog>
